module.exports = __webpack_public_path__ + "static/netWorthBox-cb9d812656dd8a41084393a1ed5c910a.png";